module.exports = __webpack_public_path__ + "img/favourite.b880dabd.svg";